
export interface AccountsState {
  accounts: Account[],
  accountItem?:AccountItem,
  protocolList:any[]
}

export interface Account {
  id: number;
  login: string;
  name: string;
  partner: string;
  protocol: string
  status: number;
  transports: string[];
}

export interface AccountItem {
  id?:number,
  login:string,
  password?:string,
  confirm_password?:string,
  partner:string,
  partner_id?:number,
  protocol:string,
  protocol_id?:number,
  transports?:string[],
  transport_id?:number | null,
  status:number,
  push_statuses?:number,
  status_report?:number,
  url?:string|null,
  max_throughput?:string,
  immediate_response_needed?:number,
  event_report?:number,
  additional_processing_rule?: string | null;
  transport?:string | null,
}

export class AccountFilter {
  name?: string = undefined
  login?:number;
  protocol?: string;
  partner?: string;
  transport?: string;
  status?: number;
  page_number: number = 1;
}

export class AccountItemImpl implements AccountItem {
  login: string;
  partner: string;
  protocol: string;
  status: number;
  push_statuses?:number;
  status_report?:number;
  max_throughput?:string;
  immediate_response_needed?:number;
  event_report?:number;
  additional_processing_rule?: string | null;
  transport?:string | null;

  constructor() {
    this.login = '';
    this.partner = '';
    this.protocol = '';
    this.status = 0;
    this.push_statuses = 0;
    this.status_report = 0;
    this.transport = ''
    this.max_throughput = '10/1000'
    this.immediate_response_needed = 1;
    this.event_report = 0;
    this.additional_processing_rule = '';
  }
}
